<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="'差异记录比对结果'"
      visible
      direction="rtl"
      :size="1000"
      @close="close"
    >
      <div class="drawer-main">
        <Main ref="main" :row="row" :columns="columns" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => {} },
    columns: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
</style>
